/**
 * Miscellaneous utilities are defined here.
 */

/**
 * @example sleep function
 * @deprecated Not in use at the moment
 */
export const sleep: (ms: number) => Promise<void> = async (ms: number) => {
  const sleepPromise = new Promise((resolve) => setTimeout(resolve, ms));
  await sleepPromise;
};

/**
 * Recursively freezes all objects nested within the given object.
 * @function deepFreeze
 * @param obj - Any Object that needs to be deep frozen
 * @returns frozen object
 */
export const deepFreeze: (obj: { [key: string]: any }) => {
  [key: string]: any;
} = (obj) => {
  Object.keys(obj).forEach((prop: string) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
};
